import React from "react";
import Index from "../../../Index";
import { useState } from "react";
import { useEffect } from "react";
import PagesIndex from "../../../PagesIndex";

function MembershipTermsAndCondition() {
    const cmsText = `
    <p>
    <strong>Exclusive Membership</strong>: Connplex Membership is invite-only and available in select cities.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Benefits</strong>: Members enjoy discounts on tickets, food &amp; beverages, and merchandise at Connplex Cinemas.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Offer Redemption</strong>: Offers are valid only at participating Connplex Cinemas and cannot be exchanged for cash.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Payment</strong>: Offers apply only to purchases made via the Connplex App. Taxes and service charges are not included in the discount.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Fees &amp; Renewal</strong>: Membership requires a fee based on the plan selected. It is non-transferable and non-refundable.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Modifications</strong>: Connplex Cinemas may change or withdraw offers without prior notice.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Termination</strong>: Membership may be suspended or revoked if terms are violated.<br>
    </p>
    <p>&nbsp;</p>
    <p>
    <strong>Privacy &amp; Communication</strong>: Members must provide personal details for registration and may receive promotional communications.<br>
    </p>
    <p>&nbsp;</p>
    <p>
      <strong>Contact</strong>: For queries, email feedback@theconnplex.com.
    </p>
  `;
  return (
    <Index.Box className="main-terms">
      <Index.Box className="cus-container">
        <Index.Box className="terms-header">
          <Index.Typography
            variant="h1"
            component="h1"
            className="terms-header-title"
          >
            Terms & Conditions
          </Index.Typography>
        </Index.Box>
        <Index.Box className="terms-body member-term-body">
          <Index.Box dangerouslySetInnerHTML={{ __html: cmsText }} />
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
}

export default MembershipTermsAndCondition;
